import {adminHttpClient} from "../commons/adminHttpClient";
import PagedList from "../commons/pagedList";
import PagedFilter from "../commons/pagedFilter";

export interface IndustryDto {
    id : string;
    name: string;
    createdAt : string;
    createdBy : string;
}

const getIndustries = (filter : PagedFilter) : Promise<PagedList<IndustryDto>> => {
    return adminHttpClient.get(`/Industries/Get`, filter);
}

export default getIndustries;